export const nonNull = (value: number | null, defaultValue: number = 0): number => {
    return value || defaultValue;
};
